// src/services/users.ts
import type { UserProfile, ID } from "../types/domain";
import { select, getById, updateById } from "./db";

const PROFILES = "profiles";

const BASE_COLUMNS = "id, full_name, avatar_url, email, created_at, updated_at";

export async function getProfile(id: ID) {
  return getById<UserProfile>(PROFILES, BASE_COLUMNS, id);
}

export async function getMyProfile(userId: ID) {
  // Alias legible
  return getProfile(userId);
}

export type UpdateProfileInput = Partial<Pick<UserProfile, "full_name" | "avatar_url">>;

export async function updateProfile(id: ID, patch: UpdateProfileInput) {
  return updateById<UserProfile>(PROFILES, id, patch, BASE_COLUMNS);
}

export async function searchProfiles(query: string) {
  let q = select<UserProfile[]>(PROFILES, BASE_COLUMNS);
  if (query && query.trim().length > 1) {
    q = q.or(`full_name.ilike.%${query}%,email.ilike.%${query}%`);
  }
  const { data, error } = await q.limit(25);
  return { data, error };
}
